import styled from "styled-components";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div`
  padding: 20px;
  width: 100%;
`;

export const StyledCard = styled(Card)`
  border-radius: 4px;
`;

export const StyledCardContent = styled(CardContent)`
  padding: 0;
`;

export const WorkingLine = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 4px;
  min-height: 235px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 8px 8px 16px;
  gap: 24px;
`;

export const HeaderTitle = styled(Typography)`
  font-size: 22px;
  font-weight: 400;
  line-height: 1.27;
  color: #202224;
  font-family: Gotham, sans-serif;
`;

export const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: stretch;
  gap: 16px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    border-radius: 4px;
    border-color: rgba(0, 0, 0, 0.23);
  }

  & .MuiInputLabel-root {
    font-size: 12px;
    line-height: 1em;
    letter-spacing: 0.0125em;
    color: rgba(0, 0, 0, 0.6);
  }

  & .MuiInputBase-input {
    font-size: 16px;
    line-height: 1.5em;
    letter-spacing: 0.009375em;
    padding: 15px 14px;
    color: rgba(0, 0, 0, 0.87);
  }

  & .MuiFormHelperText-root {
    font-size: 12px;
    line-height: 1.67em;
    letter-spacing: 0.033333em;
    color: rgba(0, 0, 0, 0.6);
    margin-top: 3px;
    margin-left: 14px;
    margin-right: 14px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: stretch;
  gap: 16px;
`;

export const InfoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const InfoText = styled(Typography)`
  font-size: 12px !important;
  line-height: 1.67em;
  letter-spacing: 0.033333em;
  color: rgba(0, 0, 0, 0.6);
  padding: 0px 14px;
`;

export const HelperTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 14px;
`;

export const EmailHighlight = styled.span`
  color: #03a9f4;
  text-decoration: underline;
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: inherit;
`;

export const StyledCardActions = styled(CardActions)`
  padding: 24px !important;
  justify-content: flex-end;
`;

export const StyledButton = styled(Button)`
  border-radius: 40px !important;
  padding: 8px 22px;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.73em;
  letter-spacing: 0.03067em;
  background-color: #d33100;
  color: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #b32900;
  }
`;

export const ButtonSpinner = styled(CircularProgress)`
  color: #ffffff;
  margin-right: 8px;
`;
